import React, { useEffect, useState, useCallback } from "react";
import CategoryComponent from "../../components/HeaderBox";
import "./index.css";
import replacementIcon from "../../../../../assets/new-product-detail-cats/header-icons/prod-deliveries-icon.svg";
import { useTranslation } from "react-i18next";
import formatDate from "../../components/HeaderBox/formatDate";
import { getUseStage41_4Totals } from "../../../../../apis/Product/UseStageFlow41Api";

export const REFRESH_USE_STAGE_41_4_TOTALS = "refresh-use-stage-41-4-totals";

const Replacement41_4Icon = () => (
  <img src={replacementIcon} alt="Replacement Icon" width={76} height={76} />
);

const Replacement41_4Header = ({
  className,
  leftBoxProps,
  rightBoxProps,
  productId,
  show,
  ...props
}) => {
  const { t } = useTranslation();
  const [totalReplacementItem, setTotalReplacementItem] = useState(null);

  const fetchTotals = useCallback(() => {
    if (productId) {
      getUseStage41_4Totals({
        productId,
        setTotals: setTotalReplacementItem,
      });
    }
  }, [productId]);

  useEffect(() => {
    fetchTotals();
  }, [fetchTotals]);

  // Listen for refresh events from table components
  useEffect(() => {
    const handleRefresh = () => {
      fetchTotals();
    };
    
    window.addEventListener(REFRESH_USE_STAGE_41_4_TOTALS, handleRefresh);

    return () => {
      window.removeEventListener(REFRESH_USE_STAGE_41_4_TOTALS, handleRefresh);
    };
  }, [fetchTotals]);

  return (
    <CategoryComponent
      show={show}
      className={`replacement-41-4-category ${className || ""}`}
      leftBoxProps={{
        icon: <Replacement41_4Icon />,
        title: t("REPLACEMENT_41_4") || "Replacement",
        description:
          t("REPLACEMENT_41_4_DESC") ||
          "Describe the effects of a full exchange of the FUs before the end of its life.",
        productId: productId,
        isSystemBoundary: true,
        customTextColor: "white",
        ...leftBoxProps,
      }}
      rightBoxProps={{
        totals: [
          {
            title: t("TOTAL_LIFECYCLE_PHASE"),
            items: [
              {
                subtitle: "",
                subitems: [],
              },
            ],
            isSwitchable: true,
          },
          // {
          //   title: t("TOTAL_FOR_FLOW_41_4") || "Total for Flow 41.4",
          //   items: [
          //     {
          //       subtitle: "",
          //       subitems: [],
          //     },
          //   ],
          //   isSwitchable: true,
          // },
        ],
        impactTotals: totalReplacementItem?.impact_totals || null,
        lastUpdated: totalReplacementItem?.updated_at
          ? formatDate(totalReplacementItem?.updated_at)
          : t("DD_MM_YYYY"),
        customTextColor: "white",
        ...rightBoxProps,
      }}
      {...props}
    />
  );
};

export default Replacement41_4Header;

